module.exports = __webpack_public_path__ + "img/checkin_step2.408463ac.jpg";